import React from 'react';
import { connect } from 'react-redux';
import Header from '../Components/Header/HeaderUnauthorized';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Divider from 'material-ui/Divider';

import {verifyUser, resendRegistrationEmail} from '../actions/authActions';

class AccessCode extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            code: ""
        };
        this.identifyDas = this.identifyDas.bind(this);
    }

    codeChange = (event) => {
        this.setState({ code: event.target.value });
    }
    identifyDas(){
        this.props.identify(this.state.code);
    }   

  render() {

    return (
        <div>
            <Header>
                <span className="white" >Verify Email</span>
            </Header>
            <br />
            <div className="container">
                <p className="white">Enter the verification code from your email</p>
                <br />
                <TextField hintText="Verification Code" value={this.state.code} onChange={this.codeChange} fullWidth={true} inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} />
                <br />
                <br />
                <RaisedButton label="Verify" primary={true} onClick={this.identifyDas} fullWidth={true} style={{height:45}}  labelStyle={{fontSize: '26px'}}  />
                <br />
                <Divider />
                <br />
                    <p className="white centered">If you didn't receive an email then please click the button below to resend it.</p>
                    <FlatButton label="Resend Email"  onClick={this.props.resend} default={true} fullWidth={true} style={{border: '1px solid #FFF', color:"#fff", height:"45px"}}   labelStyle={{fontSize: '26px'}} />
            </div>  
        </div>
    );
  }

};




const mapDispatchToProps = (dispatch) => {
  return {
    identify: (code) => {
      dispatch(verifyUser(code));
    },
    resend: () => {
      dispatch(resendRegistrationEmail());
    }
  }
}


function mapStateToProps(state) {

    const { isVerified } = state.thisApp.auth
  
  return {
    isVerified
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccessCode)





// WEBPACK FOOTER //
// ./src/Pages/AccessCode.js